export default {
    props: {
        pageableAlwaysVisible: {
            type: Boolean,
            kComposite: 'pageable.alwaysVisible'
        }, 
        pageablePageSize: {
            type: Number,
            kComposite: 'pageable.pageSize'
        }, 
        pageablePreviousNext: {
            type: Boolean,
            kComposite: 'pageable.previousNext'
        }, 
        pageableNumeric: {
            type: Boolean,
            kComposite: 'pageable.numeric'
        }, 
        pageableButtonCount: {
            type: Number,
            kComposite: 'pageable.buttonCount'
        }, 
        pageableInput: {
            type: Boolean,
            kComposite: 'pageable.input'
        }, 
        pageablePageSizes: {
            type: Boolean | Array,
            kComposite: 'pageable.pageSizes'
        }, 
        pageableRefresh: {
            type: Boolean,
            kComposite: 'pageable.refresh'
        }, 
        pageableResponsive: {
            type: Boolean,
            kComposite: 'pageable.responsive'
        }, 
        pageableInfo: {
            type: Boolean,
            kComposite: 'pageable.info'
        }, 
        pageableMessagesDisplay: {
            type: String,
            kComposite: 'pageable.messages.display'
        }, 
        pageableMessagesEmpty: {
            type: String,
            kComposite: 'pageable.messages.empty'
        }, 
        pageableMessagesPage: {
            type: String,
            kComposite: 'pageable.messages.page'
        }, 
        pageableMessagesOf: {
            type: String,
            kComposite: 'pageable.messages.of'
        }, 
        pageableMessagesItemsPerPage: {
            type: String,
            kComposite: 'pageable.messages.itemsPerPage'
        }, 
        pageableMessagesFirst: {
            type: String,
            kComposite: 'pageable.messages.first'
        }, 
        pageableMessagesLast: {
            type: String,
            kComposite: 'pageable.messages.last'
        }, 
        pageableMessagesNext: {
            type: String,
            kComposite: 'pageable.messages.next'
        }, 
        pageableMessagesPrevious: {
            type: String,
            kComposite: 'pageable.messages.previous'
        }, 
        pageableMessagesRefresh: {
            type: String,
            kComposite: 'pageable.messages.refresh'
        }, 
        pageableMessagesMorePages: {
            type: String,
            kComposite: 'pageable.messages.morePages'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-treelist-vue-wrapper/src/KendoTreeList/Pageable.js